import React from "react";
import { useDesign } from "../../context/contextDesign";
import { useAzureConfig } from "../../context/Dashboard/azure/contextConfig";
import { useThemeMode } from "../../context/contextTheme";
import Guide from "../../assets/vid/cloud/azure-guide.webm";
import ScanView from "./misconfig/ScanView";
import LoadBtn from "./loadBtn";

const AzureConfigView = () => {
  const { zoom, FadingComponent, toggleUpgradeCard } = useDesign();
  const { theme } = useThemeMode();

  const {
    handleConfigScan,
    configAssets,
    configScanLoading,
    clientId,
    setClientId,
    tenantId,
    setTenantId,
    clientSecret,
    setClientSecret,
    error,
  } = useAzureConfig();

  // ✅ DERIVED STATE (single source of truth)
  const hasConfigData =
    Array.isArray(configAssets) && configAssets.length > 0;

  return (
    <div style={{ zoom }}>
      {!hasConfigData ? (
        <div className="d-flex flex-column py-4 col-lg-6 col-md-6 col-sm-12 col-12">
          <form onSubmit={handleConfigScan}>
            <div className="mb-3">
              <div className="input-group">
                <span
                  className="input-group-text fw-bold"
                  style={{
                    color: theme.textColorInv,
                    background: theme.textColor,
                    width: 120,
                  }}
                >
                  Client ID:
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={clientId}
                  onChange={(e) => setClientId(e.target.value)}
                  placeholder="Example: AKIAIOSFODNN7EXAMPLE"
                  required
                  disabled={configScanLoading}
                />
              </div>
            </div>

            <div className="mb-3">
              <div className="input-group">
                <span
                  className="input-group-text fw-bold"
                  style={{
                    color: theme.textColorInv,
                    background: theme.textColor,
                    width: 120,
                  }}
                >
                  Client Secret:
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={clientSecret}
                  onChange={(e) => setClientSecret(e.target.value)}
                  placeholder="Example: wJalrXUtnFEMI/K7MDENG/bPxRfiCYEXAMPLEKEY"
                  required
                  disabled={configScanLoading}
                />
              </div>
            </div>

            <div className="mb-3">
              <div className="input-group">
                <span
                  className="input-group-text fw-bold"
                  style={{
                    color: theme.textColorInv,
                    background: theme.textColor,
                    width: 120,
                  }}
                >
                  Tenant ID:
                </span>
                <input
                  className="form-control"
                  type="text"
                  value={tenantId}
                  onChange={(e) => setTenantId(e.target.value)}
                  placeholder="Example: AKIAIOSFODNN7EXAMPLE"
                  required
                  disabled={configScanLoading}
                />
              </div>
            </div>

            {/* Error */}
            {error && (
              <div
                className="text-danger fw-semibold mb-2 cursor-pointer"
                onClick={error.card ? toggleUpgradeCard : null}
              >
                {error.message}
              </div>
            )}

            {/* Info */}
            <div className="text-muted small">
              <strong>Note:</strong> This misconfiguration scan may take time
              depending on your Azure environment. Please keep your credentials
              valid during the scan.
            </div>

            {/* Submit */}
            <div className="d-flex justify-content-end py-4">
              <button
                type="submit"
                disabled={configScanLoading || !clientId || !clientSecret || !tenantId}
                className="btn rounded-3 fw-medium fs-5 d-flex justify-content-center align-items-center"
                style={{
                  color: theme.textColorInv,
                  background:
                    configScanLoading || !clientId || !clientSecret || !tenantId
                      ? theme.textMuted
                      : theme.textColor,
                  width: 240,
                  height: 50,
                  opacity:
                    configScanLoading || !clientId || !clientSecret || !tenantId ? 0.7 : 1,
                  cursor:
                    configScanLoading || !clientId || !clientSecret || !tenantId
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {configScanLoading ? <LoadBtn /> : "Start Scan"}
              </button>
            </div>
          </form>

          <hr className="text-secondary" />

          {/* Guide */}
          <FadingComponent>
            <div style={{ color: theme.textColor }}>
              <div className="fw-bold fs-5 mb-3">
                Steps to get Client ID,  Client Secret, Tenant ID
              </div>
              <video
                className="w-100 rounded-4 border shadow-sm"
                src={Guide}
                controls
                autoPlay
                muted
              />
            </div>
          </FadingComponent>
        </div>
      ) : (
        <ScanView />
      )}
    </div>
  );
};

export default AzureConfigView;
